import { render, staticRenderFns } from "./LineLimitSetHistory.vue?vue&type=template&id=596b4c96"
import script from "./LineLimitSetHistory.vue?vue&type=script&lang=js"
export * from "./LineLimitSetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports